import emailjs from '@emailjs/browser';

// Initialize EmailJS with your User ID
emailjs.init('LHN36zibZMdIZeRb7');

// Function to get IP address
const getIPAddress = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('Failed to get IP address:', error);
    return 'IP address not available';
  }
};

// Function to send confirmation email to user
const sendConfirmationEmail = async (userEmail, formType, formData) => {
  try {
    const templateParams = {
      to_email: userEmail,  // Recipient's email
      from_email: 'reachus@lawsuitfortruckaccident.com',
      to_name: 'Lawsuit For Truck Accident',
      from_name: 'reachus@lawsuitfortruckaccident.com',
      subject: `Thank you for your ${formType} submission`,
      message: `Thank you for submitting your ${formType}. We have received your information and will get back to you soon.`,
      name: 'Lawsuit For Truck Accident',
      form_type: formType,
      submission_date: new Date().toLocaleDateString(),
      reply_to: 'reachus@lawsuitfortruckaccident.com',
      user_email: userEmail  // Adding this to ensure the template uses the correct email
    };

    // Send confirmation email to user
    const response = await emailjs.send(
      'service_kdsm3um',
      'template_3t5wnpg',
      templateParams,
      'LHN36zibZMdIZeRb7'  // Adding the user ID explicitly
    );
    
    return { success: true, response };
  } catch (error) {
    console.error('Failed to send confirmation email:', error);
    return { success: false, error };
  }
};

// Function to send claim form data
export const sendClaimFormEmail = async (formData) => {
  try {
    const ipAddress = await getIPAddress();
    const templateParams = {
      to_email: 'reachus@lawsuitfortruckaccident.com',
      from_email: 'reachus@lawsuitfortruckaccident.com',
      name: formData.name,
      phone: formData.phone,
      email: formData.email,
      state: formData.state,
      certId:formData.certId,
      pingUrl:formData.pingUrl,
      tokenUrl:formData.tokenUrl,
      accidentDate: formData.accidentDate,
      accidentTime: formData.accidentTime,
      accidentLocation: formData.accidentLocation,
      accidentDescription: formData.accidentDescription,
      otherVehiclesTruck: formData.otherVehicles.truck ? 'Yes' : 'No',
      otherVehiclesBus: formData.otherVehicles.bus ? 'Yes' : 'No',
      otherVehiclesCar: formData.otherVehicles.car ? 'Yes' : 'No',
      otherVehiclesOthers: formData.otherVehicles.others ? 'Yes' : 'No',
      documentsPoliceReport: formData.documents.policeReport ? 'Yes' : 'No',
      documentsMedicalReport: formData.documents.medicalReport ? 'Yes' : 'No',
      documentsAccidentPhotos: formData.documents.accidentPhotos ? 'Yes' : 'No',
      needHelp: formData.needHelp ? 'Yes' : 'No',
      accidentDateTime: formData.accidentDateTime,
      ipAddress: ipAddress,
      page_source: 'ClaimForm'
    };

    // Send admin notification
    const response = await emailjs.send(
      'service_kdsm3um',
      'template_05r5mg4',
      templateParams
    );

    // Send confirmation email to user if email is provided
    if (formData.email) {
      try {
        await sendConfirmationEmail(formData.email, 'claim form', formData);
      } catch (confirmationError) {
        console.error('Failed to send confirmation email:', confirmationError);
        // Don't fail the whole submission if confirmation fails
      }
    }
    
    return { success: true, response };
  } catch (error) {
    console.error('Failed to send email:', error);
    return { success: false, error };
  }
};

// Function to send contact form data
export const sendContactFormEmail = async (formData) => {
  try {
    const ipAddress = await getIPAddress();
const templateParams = {
  to_email: 'reachus@lawsuitfortruckaccident.com',
  from_email: 'reachus@lawsuitfortruckaccident.com',
  name: formData.name,
  phoneNumber: formData.phoneNumber,
  email: formData.email,
  category: formData.category,
  concern: formData.concern,
  caseHistory: formData.caseHistory,
  ipAddress: ipAddress,
  certId: formData.certId,
  pingUrl: formData.pingUrl,
  tokenUrl: formData.tokenUrl,
  page_source: 'ContactUs'
};


    // Send admin notification
    const response = await emailjs.send(
      'service_kdsm3um',
      'template_ml6wcb6',
      templateParams
    );

    // Send confirmation email to user if email is provided
    if (formData.email) {
      try {
        await sendConfirmationEmail(formData.email, 'contact form', formData);
      } catch (confirmationError) {
        console.error('Failed to send confirmation email:', confirmationError);
        // Don't fail the whole submission if confirmation fails
      }
    }
    
    return { success: true, response };
  } catch (error) {
    console.error('Failed to send email:', error);
    return { success: false, error };
  }
};

// Function to send newsletter subscription
export const sendNewsletterSubscription = async (email, pageSource = '') => {
  try {
    const ipAddress = await getIPAddress();
    const templateParams = {
      to_email: 'reachus@lawsuitfortruckaccident.com',
      from_email: 'reachus@lawsuitfortruckaccident.com',
      subscriber_email: email,
      message: `New newsletter subscription from ${email}`,
      ip_address: ipAddress,
      page_source: pageSource || 'Unknown',
      subject: 'Newsletter Subscription'
    };

    // Send admin notification
    const response = await emailjs.send(
      'service_kdsm3um',
      'template_ysosj1s',
      templateParams
    );

    // Send confirmation email to subscriber
    try {
      await sendConfirmationEmail(email, 'newsletter subscription', { email });
    } catch (confirmationError) {
      console.error('Failed to send confirmation email:', confirmationError);
      // Don't fail the whole subscription if confirmation fails
    }
    
    return { success: true, response };
  } catch (error) {
    console.error('Failed to send subscription email:', error);
    return { success: false, error };
  }
}; 